<script>
  export default {
    name: 'AlertSnackBar',

    data: () => ({
      text: '',
      type: null,
      showSnackBar: false,
    }),

    computed: {
      alertSnackBar() {
        return this.$store.getters.getAlertSnackBar;
      },
    },

    watch: {
      alertSnackBar(value) {
        this.showSnackBar = !!value;

        if (!value) {
          return;
        }

        const { text, type } = value;

        this.text = text;
        this.type = type;
      },
    },
  };
</script>

<template>
  <v-snackbar v-model="showSnackBar" :timeout="5000" absolute bottom centered class="alert-snackbar alert-shadow">
    <span class="text-body-1 font-weight-600">{{ text }}</span>

    <template #action="{ attrs }">
      <v-btn icon v-bind="attrs" @click="showSnackBar = false">
        <v-icon color="white" size="18">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style lang="scss" scoped>
  .alert-snackbar {
    z-index: 999;

    &::v-deep .v-snack__wrapper {
      min-width: 250px !important;
    }

    &::v-deep .v-snack__wrapper.v-sheet {
      border-radius: 8px;
      background: linear-gradient(-35deg, rgba(67, 37, 89, 1) 27%, rgba(135, 121, 182, 1) 100%);
      position: fixed;
      top: unset;
      bottom: 0;

      @media screen and (max-width: 768px) {
        bottom: 80px;
      }
    }
  }
</style>
